import React from 'react';

export default function TermsAndConditions() {
  return (
    <div className="pt-28 pb-20 bg-amber-50 min-h-screen">
      <div className="max-w-4xl mx-auto px-6">
        <h1 className="section-title mb-10">Terms & Conditions</h1>

        <div className="space-y-6 text-amber-800 leading-relaxed">
          <p>
            By accessing and using this website, you agree to comply with the
            following terms and conditions.
          </p>

          <div>
            <h2 className="font-display text-2xl text-amber-900 mb-3">
              Use of Website
            </h2>
            <p>
              The content on this website is provided for informational and
              non-profit organizational purposes only. Users agree to use this website in a lawful
              manner and respect the intellectual property rights of Bhojan Seva Mandal Foundation.
            </p>
          </div>

          <div>
            <h2 className="font-display text-2xl text-amber-900 mb-3">
              Membership — General Terms
            </h2>
            <p>
              Membership contributions to BSM Bhojan Seva Mandal Foundation are voluntary contributions
              made to avail a membership plan. BSM Bhojan Seva
              Mandal Foundation is a registered non-profit organization (Registration No. 173136)
              with 80G tax exemption status.
            </p>
            <p className="mt-3">
              Membership contributions are generally non-refundable except in cases of processing errors,
              duplicate transactions, or unauthorized debits, which must be reported
              within 7 days of the transaction.
            </p>
          </div>

          <div>
            <h2 className="font-display text-2xl text-amber-900 mb-3">
              Recurring Membership & Mandate Information
            </h2>
            <p className="font-semibold text-amber-900 mb-2">
              Important: Please read this section carefully before setting up a recurring membership.
            </p>
            <div className="space-y-3 text-sm bg-orange-50 p-4 border-l-4 border-orange-500 rounded-sm">
              <p>
                <strong>Membership Amount:</strong> By proceeding with a recurring membership,
                you authorize BSM Bhojan Seva Mandal Foundation to collect the selected
                membership amount at the chosen frequency.
              </p>
              <p>
                <strong>Payment Frequency:</strong> Recurring memberships will debit your
                selected payment method on the same date each month until you cancel the mandate.
              </p>
              <p>
                <strong>Payment Gateway:</strong> All membership payments are processed through Razorpay,
                a secure, RBI-regulated payment gateway. Razorpay may require OTP or bank
                authentication for mandate activation. Your bank account and card details are
                not stored by BSM Bhojan Seva Mandal Foundation.
              </p>
              <p>
                <strong>Cancellation & Modification:</strong> You can cancel, pause, or modify
                your recurring membership mandate at any time by:
              </p>
              <ul className="list-disc list-inside ml-2 space-y-1">
                <li>Updating or revoking the mandate through your bank/UPI app, OR</li>
                <li>Contacting BSM Bhojan Seva Mandal Foundation at <a href="mailto:bsmbhojansevamandalfoundation@gmail.com" className="text-orange-600 underline">bsmbhojansevamandalfoundation@gmail.com</a> or +91 90817 95075</li>
              </ul>
              <p className="mt-2">
                Cancellation takes effect within 1-2 business days. There are no penalties,
                lock-in periods, or hidden charges for cancellation.
              </p>
              <p>
                <strong>Mandate Duration:</strong> Once activated, the mandate remains valid
                until you cancel it. Recurring memberships are not one-time contributions.
              </p>
              <p>
                <strong>Confirmation & Receipts:</strong> You will receive an email and SMS
                confirmation for each membership transaction. 80G tax receipts will be provided
                annually or upon request.
              </p>
              <p>
                <strong>Dispute Resolution:</strong> If you see an unauthorized or duplicate
                debit, contact your bank immediately (within 7 days) or email us at{' '}
                <a href="mailto:bsmbhojansevamandalfoundation@gmail.com" className="text-orange-600 underline">
                  bsmbhojansevamandalfoundation@gmail.com
                </a>. We will investigate and process a refund to your original payment method
                if the transaction is confirmed as erroneous.
              </p>
              <p>
                <strong>Consent:</strong> By proceeding with a recurring membership, you explicitly
                consent to create a recurring payment mandate and acknowledge that you have read
                and understood these terms.
              </p>
            </div>
          </div>

          <div>
            <h2 className="font-display text-2xl text-amber-900 mb-3">
              Use of Funds
            </h2>
            <p>
              Membership contributions are used for:
              <ul className="list-disc pl-5 space-y-1">
                <li>(A) Publishing and distributing journals in digital and print formats</li>
                <li>(B) Logistics for member participation in food distribution campaigns</li>
                <li>(C) Operational costs of journal editorial and community welfare programs</li>
              </ul>
              All activities serve our mission of knowledge sharing and welfare in Gujarat.
            </p>
          </div>

          <div>
            <h2 className="font-display text-2xl text-amber-900 mb-3">
              Intellectual Property
            </h2>
            <p>
              All website content including text, graphics, images, and branding belongs
              to BSM Bhojan Seva Mandal Foundation unless otherwise stated. No part of this
              website may be reproduced, distributed, or transmitted without prior written
              permission.
            </p>
          </div>

          <div>
            <h2 className="font-display text-2xl text-amber-900 mb-3">
              Limitation of Liability
            </h2>
            <p>
              BSM Bhojan Seva Mandal Foundation is not liable for any technical issues, payment
              failures, or delays caused by third-party service providers (including Razorpay,
              banks, or UPI networks). For payment-related issues, contact Razorpay support
              or your bank directly.
            </p>
          </div>

          <div>
            <h2 className="font-display text-2xl text-amber-900 mb-3">
              Changes to Terms
            </h2>
            <p>
              We reserve the right to update these terms at any time. Changes will be posted
              on this page with an updated date. Continued use of the website constitutes
              acceptance of the updated terms.
            </p>
          </div>

          <div>
            <h2 className="font-display text-2xl text-amber-900 mb-3">
              Governing Law
            </h2>
            <p>
              These terms are governed by the laws of India. Any disputes shall be subject
              to the jurisdiction of courts in Rajkot, Gujarat.
            </p>
          </div>

          <div>
            <h2 className="font-display text-2xl text-amber-900 mb-3">
              Contact Us
            </h2>
            <p>
              If you have questions about these terms or need support, contact us at:
            </p>
            <div className="mt-3 p-4 bg-white border border-amber-200 rounded-sm space-y-2 text-sm">
              <p><strong>Email:</strong> <a href="mailto:bsmbhojansevamandalfoundation@gmail.com" className="text-orange-600 underline">bsmbhojansevamandalfoundation@gmail.com</a></p>
              <p><strong>Phone:</strong> +91 90817 95075</p>
              <p><strong>Address:</strong> Amrut Complex 2nd floor, Opp. Royal Stationary, Anand Banglows chowk, Mavdi mainroad, Rajkot – 360004, Gujarat, India</p>
            </div>
          </div>

          <div className="mt-10 p-5 bg-amber-100 border border-amber-300 rounded-sm text-center">
            <p className="text-xs text-amber-900">
              <strong>Last Updated:</strong> July 2026
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}